import "cookieconsent";
import Vue from "vue";
import Vuex from "vuex";
import VueTouch from "vue-touch";
import BootstrapVue from "bootstrap-vue";
import { VLazyImagePlugin } from "v-lazy-image";
import VueCarousel from "vue-carousel";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from "@fortawesome/vue-fontawesome";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import { Integrations as ApmIntegrations } from "@sentry/apm";
import vClickOutside from "v-click-outside";
import AsyncComputed from "vue-async-computed";
import WebAccount from "spiritweb.packages.web-account";
import { GtagPlugin } from "spiritweb.packages.ecommerce";
import Cookie from "~/Scripts/modules/cookie";
import store from "~/Scripts/store";

// common
import BreadcrumbMenu from "~/Components/Common/BreadcrumbMenu.vue";
import ProgressIcon from "~/Components/Common/ProgressIcon.vue";
import CustomModal from "~/Components/Common/Modal/CustomModal.vue";
import LoadingSpinner from "~/Components/Common/LoadingSpinner.vue";
import NavigationButtonList from "~/Components/Layout/NavigationButtonList.vue";
import MiniBasket from "~/Components/Basket/MiniBasket.vue";

// package styling
import "spiritweb.packages.ecommerce/dist/spiritweb.packages.ecommerce.min.css";
import "spiritweb.packages.web-account/dist/spiritweb.packages.web-account.min.css";

Vue.use( Vuex );
Vue.use( VueTouch );
Vue.use( BootstrapVue );
Vue.use( VLazyImagePlugin );
Vue.use( VueCarousel );
Vue.use( vClickOutside );
Vue.use( AsyncComputed );
Vue.use( WebAccount, { store } );
Vue.use( GtagPlugin );

Vue.component( "font-awesome-icon", FontAwesomeIcon );
Vue.component( "font-awesome-layers", FontAwesomeLayers );
Vue.component( "breadcrumb-menu", BreadcrumbMenu );

Vue.component( "progress-icon", ProgressIcon );
Vue.component( "loading-spinner", LoadingSpinner );
Vue.component( "custom-modal", CustomModal );

Vue.component( "navigation-button-list", NavigationButtonList );
Vue.component( "mini-basket", MiniBasket );

if ( process.env.NODE_ENV === "production" ) {
  Sentry.init( {
    dsn: "https://b9e8fabf91954b6b87d3401e2fe94dc4@o351484.ingest.sentry.io/5421237",
    integrations: [
      new ApmIntegrations.Tracing(),
      new Integrations.Vue( {
        Vue,
        attachProps: true,
        tracing: true,
        tracingOptions: {
          trackComponents: true,
        },
      } ),
    ],
    tracesSampleRate: 0.33,
  } );
}

const csrfToken = document.querySelector( "meta[name=\"csrf-token\"]" ).getAttribute( "content" );
Vue.prototype.$csrfToken = csrfToken;

document.addEventListener( "DOMContentLoaded", () => {
  window.cookieconsent.initialise( {
    position: "top",
    static: true,
    content: {
      message: `We use cookies on our website to enable some essential functions for you in 
        accordance with our <a href="/cookie-policy">cookie policy</a>. We'd also like your 
        permission to store cookies to help us understand how visitors are using our website 
        so we can improve the experience for them.`,
      deny: "No thanks",
      allow: "That's ok",
      href: "/cookies/",
    },
    showLink: false,
    type: "opt-in",
    compliance: {
      "opt-in": "<div class=\"cc-compliance cc-highlight\">{{deny}}{{allow}}</div>",
    },
    onStatusChange () {
      const didConsent = this.hasConsented();
      if ( didConsent ) {
        Cookie.acceptCookies();
      }
      if ( !didConsent ) {
        Cookie.denyCookies();
      }
    },
    onRevokeChoice () {
      const { type } = this.options;
      if ( type === "opt-in" ) {
        Cookie.acceptCookies();
      }
      if ( type === "opt-out" ) {
        Cookie.denyCookies();
      }
    },
  } );
} );
